// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */

.health-monitor-app {
    min-height: 100vh;
    background: linear-gradient(135deg, #e0e7ff 0%, #f3e8ff 50%, #fce7f3 100%);
    font-family: system-ui, -apple-system, sans-serif;
}

.app-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
}


/* Header */

.header {
    text-align: center;
    margin-bottom: 2rem;
}

.logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.logo-icon {
    position: relative;
}

.heart-icon {
    width: 3.5rem;
    height: 3.5rem;
    color: #f43f5e;
    animation: pulse 2s infinite;
}

.heart-icon-ping {
    position: absolute;
    inset: 0;
    width: 3.5rem;
    height: 3.5rem;
    color: #f43f5e;
    opacity: 0.2;
    animation: ping 2s infinite;
}

.app-title {
    font-size: 3.75rem;
    font-weight: 800;
    background: linear-gradient(to right, #4f46e5 0%, #7c3aed 50%, #db2777 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.app-subtitle {
    color: #4b5563;
    font-size: 1.25rem;
    font-weight: 500;
    margin-bottom: 0.75rem;
}

.status-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.status-dot {
    width: 0.5rem;
    height: 0.5rem;
    background-color: #10b981;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

.status-text {
    font-size: 0.875rem;
    color: #6b7280;
}


/* Error Message */

.error-message {
    margin-bottom: 1.5rem;
    padding: 1rem;
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 0.75rem;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
}

.error-icon {
    width: 1.25rem;
    height: 1.25rem;
    color: #ef4444;
    flex-shrink: 0;
    margin-top: 0.125rem;
}

.error-title {
    color: #991b1b;
    font-weight: 500;
    margin-bottom: 0.25rem;
}

.error-detail {
    color: #dc2626;
    font-size: 0.875rem;
}


/* Main Card */

.main-card {
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(12px);
    border-radius: 1.5rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.2);
    overflow: hidden;
}

/* Prefill Form */

.prefill-state {
    padding: 2rem 1rem 3rem;
}

.prefill-card {
    max-width: 760px;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.96);
    border-radius: 1.75rem;
    box-shadow: 0 24px 50px rgba(15, 23, 42, 0.09);
    border: 1px solid rgba(148, 163, 184, 0.16);
    padding: 2rem;
}

.prefill-header {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 1rem;
    align-items: center;
}

.prefill-icon-wrap {
    width: 3rem;
    height: 3rem;
    border-radius: 1rem;
    display: grid;
    place-items: center;
    background: #eef2ff;
    color: #4338ca;
}

.prefill-icon {
    width: 1.4rem;
    height: 1.4rem;
}

.prefill-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #111827;
    margin: 0;
}

.prefill-subtitle {
    margin: 0.5rem 0 0;
    color: #475569;
    line-height: 1.7;
    font-size: 0.98rem;
}

.prefill-section {
    margin-top: 2rem;
}

.prefill-section-label {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    color: #0f172a;
    font-weight: 600;
    margin-bottom: 1rem;
}

.optional-tag {
    color: #64748b;
    font-size: 0.92rem;
    font-weight: 500;
}

.ground-truth-inputs {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr;
}

@media (min-width: 640px) {
    .ground-truth-inputs.two-column-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

.vitals-grid {
    grid-template-columns: 1fr;
}

@media (min-width: 768px) {
    .vitals-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

.input-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.input-group.full-width {
    grid-column: span 1;
}

@media (min-width: 768px) {
    .input-group.full-width {
        grid-column: 1 / -1;
    }
}

.input-label {
    color: #334155;
    font-size: 0.92rem;
    font-weight: 600;
}

.input-field {
    width: 100%;
    border: 1px solid #cbd5e1;
    border-radius: 0.95rem;
    padding: 0.95rem 1rem;
    font-size: 1rem;
    color: #0f172a;
    background-color: #f8fafc;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.input-field:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);
}

.textarea-field {
    min-height: 5rem;
    resize: vertical;
}

.input-with-unit {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.input-unit {
    color: #64748b;
    font-size: 0.95rem;
    min-width: 3rem;
}

.prefill-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.875rem;
    margin-top: 2rem;
}

.prefill-start-button {
    position: relative;
    padding: 1rem 1.75rem;
    background: #4338ca;
    color: white;
    border-radius: 1rem;
    font-weight: 700;
    font-size: 1rem;
    border: none;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
    box-shadow: 0 12px 24px rgba(67, 56, 202, 0.18);
}

.prefill-start-button:hover {
    transform: translateY(-1px);
    background: #4f46e5;
}

.prefill-cancel-button {
    padding: 0.95rem 1.5rem;
    background-color: #f8fafc;
    color: #334155;
    border-radius: 1rem;
    font-weight: 600;
    border: 1px solid #cbd5e1;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.prefill-cancel-button:hover {
    background-color: #f1f5f9;
}

/* Idle State */

.idle-state {
    padding: 3rem;
    text-align: center;
}

.idle-content {
    margin-bottom: 2rem;
}

.camera-icon-container {
    position: relative;
    display: inline-block;
    margin-bottom: 2rem;
}

.camera-icon-background {
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, #818cf8 0%, #a78bfa 100%);
    border-radius: 50%;
    filter: blur(2rem);
    opacity: 0.3;
    animation: pulse 2s infinite;
}

.camera-icon {
    position: relative;
    width: 7rem;
    height: 7rem;
    color: #4f46e5;
}

.idle-title {
    font-size: 2.25rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 1rem;
}

.idle-description {
    color: #4b5563;
    font-size: 1.125rem;
    margin-bottom: 2rem;
    max-width: 42rem;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.75;
}


/* Start Button */

.start-button {
    position: relative;
    padding: 1.25rem 2.5rem;
    background: linear-gradient(to right, #4f46e5 0%, #7c3aed 50%, #db2777 100%);
    color: white;
    border-radius: 1rem;
    font-weight: 700;
    font-size: 1.25rem;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 10px 25px rgba(168, 85, 247, 0.3);
    transform: scale(1);
}

.start-button:hover {
    box-shadow: 0 25px 50px rgba(168, 85, 247, 0.5);
    transform: scale(1.05);
}

.button-content {
    position: relative;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    justify-content: center;
}

.button-icon {
    width: 1.5rem;
    height: 1.5rem;
}

.button-hover {
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, #db2777 0%, #7c3aed 50%, #4f46e5 100%);
    border-radius: 1rem;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.start-button:hover .button-hover {
    opacity: 1;
}


/* Features Grid */

.features-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 4rem;
    max-width: 64rem;
    margin-left: auto;
    margin-right: auto;
}

@media (min-width: 768px) {
    .features-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}

.feature-card {
    padding: 1.5rem;
    border-radius: 1rem;
    border: 2px solid;
    transition: all 0.3s ease;
    transform: scale(1);
}

.feature-card:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
    transform: scale(1.05);
}

.feature-card-1 {
    background: linear-gradient(135deg, #ffe4e6 0%, #fce7f3 100%);
    border-color: #fecdd3;
}

.feature-card-2 {
    background: linear-gradient(135deg, #dbeafe 0%, #cffafe 100%);
    border-color: #bae6fd;
}

.feature-card-3 {
    background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);
    border-color: #e9d5ff;
}

.feature-card-4 {
    background: linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%);
    border-color: #fde68a;
}

.feature-icon {
    width: 3rem;
    height: 3rem;
    margin: 0 auto 1rem;
    display: block;
    transition: transform 0.3s ease;
}

.feature-card:hover .feature-icon {
    transform: scale(1.1);
}

.feature-card-1 .feature-icon {
    color: #f43f5e;
}

.feature-card-2 .feature-icon {
    color: #3b82f6;
}

.feature-card-3 .feature-icon {
    color: #8b5cf6;
}

.feature-card-4 .feature-icon {
    color: #f59e0b;
}

.feature-title {
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.25rem;
}

.feature-description {
    font-size: 0.875rem;
    color: #4b5563;
}


/* Camera State */

.camera-state {
    padding: 2rem;
}

.video-container {
    position: relative;
    border-radius: 1.5rem;
    overflow: hidden;
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    margin-bottom: 1.5rem;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

.video-preview {
    width: 100%;
    height: 500px;
    object-fit: cover;
    display: block;
}

.video-overlay {
    position: absolute;
    inset: 0;
    border: 4px solid #34d399;
    border-radius: 1.5rem;
    pointer-events: none;
}

.face-guide {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.face-guide-circle {
    width: 18rem;
    height: 24rem;
    border: 4px solid #86efac;
    border-radius: 50%;
    opacity: 0.4;
    animation: pulse 2s infinite;
}

.camera-status {
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    padding: 0.5rem 1rem;
    border-radius: 9999px;
}

.status-indicator-dot {
    width: 0.5rem;
    height: 0.5rem;
    background-color: #34d399;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

.camera-status .status-text {
    color: white;
    font-weight: 500;
    font-size: 0.875rem;
}

.camera-controls {
    text-align: center;
}

.camera-instructions {
    color: #374151;
    font-size: 1.125rem;
    font-weight: 500;
    margin-bottom: 1.5rem;
}

.control-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
}

.record-button {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 2.5rem;
    background: linear-gradient(to right, #f43f5e 0%, #dc2626 100%);
    color: white;
    border-radius: 1rem;
    font-weight: 700;
    font-size: 1.125rem;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 20px 50px rgba(244, 63, 94, 0.3);
    transform: scale(1);
}

.record-button:hover {
    box-shadow: 0 25px 50px rgba(244, 63, 94, 0.5);
    transform: scale(1.05);
}

.recording-dot {
    width: 1rem;
    height: 1rem;
    background-color: white;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

.cancel-button {
    padding: 1rem 2.5rem;
    background-color: #f3f4f6;
    color: #374151;
    border-radius: 1rem;
    font-weight: 700;
    font-size: 1.125rem;
    border: 2px solid #e5e7eb;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-button:hover {
    background-color: #e5e7eb;
}


/* Recording State */

.recording-state {
    padding: 2rem;
}

.recording-video-container {
    position: relative;
    border-radius: 1rem;
    overflow: hidden;
    background-color: black;
    margin-bottom: 1.5rem;
}

.recording-video {
    width: 100%;
    height: 480px;
    object-fit: cover;
    display: block;
}

.recording-indicator {
    position: absolute;
    top: 1rem;
    left: 1rem;
    background-color: #ef4444;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
}

.recording-dot-active {
    width: 0.75rem;
    height: 0.75rem;
    background-color: white;
    border-radius: 50%;
    animation: pulse 1s infinite;
}

.recording-timer {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.timer-icon {
    width: 1.25rem;
    height: 1.25rem;
}

.timer-value {
    font-size: 1.5rem;
    font-weight: 700;
}

.timer-total {
    color: #d1d5db;
}

.progress-bar-container {
    position: relative;
    height: 0.75rem;
    background-color: #e5e7eb;
    border-radius: 9999px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background: linear-gradient(to right, #3b82f6 0%, #8b5cf6 100%);
    transition: width 1s ease;
}

.recording-instructions {
    text-align: center;
    color: #4b5563;
    margin-top: 1rem;
}


/* Processing State */

.processing-state {
    padding: 3rem;
    text-align: center;
}

.processing-content {
    margin-bottom: 2rem;
}

.processing-icon {
    width: 5rem;
    height: 5rem;
    color: #3b82f6;
    animation: spin 2s linear infinite;
    margin: 0 auto 1.5rem;
}

.processing-title {
    font-size: 1.875rem;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 1rem;
}

.processing-description {
    color: #4b5563;
    margin-bottom: 2rem;
}

.processing-progress {
    max-width: 28rem;
    margin: 0 auto;
}

.progress-bar-processing {
    height: 100%;
    background: linear-gradient(to right, #3b82f6 0%, #8b5cf6 100%);
    transition: width 0.5s ease;
}

.progress-text {
    color: #6b7280;
    margin-top: 0.5rem;
}


/* Results State */

.results-state {
    padding: 2rem;
}

.results-header {
    text-align: center;
    margin-bottom: 2.5rem;
}

.success-icon-container {
    position: relative;
    display: inline-block;
    margin-bottom: 1rem;
}

.success-icon {
    width: 5rem;
    height: 5rem;
    color: #10b981;
}

.success-icon-ping {
    position: absolute;
    inset: 0;
    width: 5rem;
    height: 5rem;
    color: #10b981;
    opacity: 0.2;
    animation: ping 2s infinite;
}

.results-title {
    font-size: 2.25rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.5rem;
}

.results-subtitle {
    color: #4b5563;
    font-size: 1.125rem;
}


/* Results Grid */

.results-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.25rem;
    margin-bottom: 2rem;
}

@media (min-width: 768px) {
    .results-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1024px) {
    .results-grid {
        grid-template-columns: repeat(5, 1fr);
    }
}

.result-card {
    padding: 1.5rem;
    border-radius: 1.5rem;
    border: 2px solid;
    transition: all 0.3s ease;
    transform: scale(1);
}

.result-card:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    transform: scale(1.05);
}

.result-card-1 {
    background: linear-gradient(135deg, #ffe4e6 0%, #fce7f3 100%);
    border-color: #fecdd3;
}

.result-card-2 {
    background: linear-gradient(135deg, #dbeafe 0%, #cffafe 100%);
    border-color: #bae6fd;
}

.result-card-3 {
    background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);
    border-color: #e9d5ff;
}

.result-card-4 {
    background: linear-gradient(135deg, #ffedd5 0%, #fef3c7 100%);
    border-color: #fed7aa;
}

.result-card-5 {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
    border-color: #a7f3d0;
}

.result-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
}

.result-icon {
    width: 2rem;
    height: 2rem;
}

.result-card-1 .result-icon {
    color: #f43f5e;
}

.result-card-2 .result-icon {
    color: #3b82f6;
}

.result-card-3 .result-icon {
    color: #8b5cf6;
}

.result-card-4 .result-icon {
    color: #f97316;
}

.result-card-5 .result-icon {
    color: #10b981;
}

.result-status {
    font-size: 0.75rem;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
    font-weight: 500;
}

.status-normal {
    background-color: #dcfce7;
    color: #166534;
}

.status-warning {
    background-color: #fef3c7;
    color: #854d0e;
}

.status-high {
    background-color: #fee2e2;
    color: #991b1b;
}

.status-below {
    background-color: #dbeafe;
    color: #1e40af;
}

.result-label {
    font-size: 0.875rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.5rem;
}

.result-value-container {
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
}

.result-value {
    font-size: 2.25rem;
    font-weight: 700;
    color: #111827;
}

.result-unit {
    color: #6b7280;
    font-size: 1rem;
}


/* Scan Details */

.scan-details {
    background-color: #f9fafb;
    border-radius: 1rem;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.scan-details-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 1rem;
}

.scan-details-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
}

.detail-label {
    font-size: 0.875rem;
    color: #6b7280;
    margin-bottom: 0.25rem;
}

.detail-value {
    font-size: 1.125rem;
    font-weight: 700;
    color: #111827;
}


/* Disclaimer */

.disclaimer {
    background-color: #fffbeb;
    border: 2px solid #fcd34d;
    border-radius: 1rem;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
}

.disclaimer-icon {
    width: 1.5rem;
    height: 1.5rem;
    color: #d97706;
    flex-shrink: 0;
    margin-top: 0.125rem;
}

.disclaimer-title {
    font-weight: 700;
    color: #78350f;
    margin-bottom: 0.5rem;
}

.disclaimer-text {
    font-size: 0.875rem;
    color: #92400e;
    line-height: 1.5;
}


/* New Scan Container */

.new-scan-container {
    text-align: center;
}


/* Footer */

.footer {
    text-align: center;
    margin-top: 2rem;
}

.footer-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(4px);
    padding: 0.5rem 1rem;
    border-radius: 9999px;
}

.footer-text {
    font-size: 0.875rem;
    color: #4b5563;
}


/* Ground Truth Section */

.ground-truth-section {
    margin-top: 2rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, #fef3c7 0%, #fef3c7 50%, #fce7f3 100%);
    border: 2px solid #fcd34d;
    border-radius: 1rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.ground-truth-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 0.5rem;
}

.ground-truth-description {
    color: #4b5563;
    font-size: 0.95rem;
    margin-bottom: 1.5rem;
    line-height: 1.5;
}

.ground-truth-inputs {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.input-group {
    display: flex;
    flex-direction: column;
}

.input-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 0.5rem;
}

.input-field {
    padding: 0.75rem;
    border: 2px solid #e5e7eb;
    border-radius: 0.5rem;
    font-size: 1rem;
    font-family: inherit;
    transition: all 0.2s ease;
}

.input-field:focus {
    outline: none;
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
    background-color: #f9f5ff;
}

.textarea-field {
    resize: vertical;
    font-family: inherit;
}

.save-ground-truth-button {
    width: 100%;
    padding: 0.875rem 1.5rem;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    border-radius: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.3);
}

.save-ground-truth-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 12px rgba(16, 185, 129, 0.4);
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
}

.save-ground-truth-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.ground-truth-note {
    font-size: 0.8rem;
    color: #6b7280;
    margin-top: 0.5rem;
}

.ground-truth-saved {
    margin-top: 2rem;
    padding: 1.5rem;
    background-color: #f0fdf4;
    border: 2px solid #86efac;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
}

.success-icon-small {
    width: 1.5rem;
    height: 1.5rem;
    color: #10b981;
    flex-shrink: 0;
}

.saved-message {
    color: #166534;
    font-weight: 500;
    margin: 0;
}


/* Animations */

@keyframes pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

@keyframes ping {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    75%,
    100% {
        transform: scale(2);
        opacity: 0;
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/HealthMonitorApp.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,iBAAiB;IACjB,0EAA0E;IAC1E,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;;AAGA,WAAW;;AAEX;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,cAAc;IACd,cAAc;IACd,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4EAA4E;IAC5E,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;;AAGA,kBAAkB;;AAElB;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;;AAGA,cAAc;;AAEd;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,qBAAqB;IACrB,iDAAiD;IACjD,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA,iBAAiB;;AAEjB;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,2CAA2C;IAC3C,sBAAsB;IACtB,8CAA8C;IAC9C,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iFAAiF;IACjF,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,+DAA+D;IAC/D,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,uBAAuB;IACvB,4EAA4E;IAC5E,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,4EAA4E;IAC5E,mBAAmB;IACnB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;;AAGA,kBAAkB;;AAElB;IACI,aAAa;IACb,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;;AAGA,iBAAiB;;AAEjB;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,6DAA6D;IAC7D,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oCAAoC;IACpC,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,+DAA+D;IAC/D,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,oBAAoB;;AAEpB;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,+DAA+D;IAC/D,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;;AAGA,qBAAqB;;AAErB;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,+DAA+D;IAC/D,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;;AAGA,kBAAkB;;AAElB;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;;AAGA,iBAAiB;;AAEjB;IACI,aAAa;IACb,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD,sBAAsB;AAC1B;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA,iBAAiB;;AAEjB;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;;AAGA,eAAe;;AAEf;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;;AAGA,uBAAuB;;AAEvB;IACI,kBAAkB;AACtB;;;AAGA,WAAW;;AAEX;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,0CAA0C;IAC1C,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;;AAGA,yBAAyB;;AAEzB;IACI,gBAAgB;IAChB,eAAe;IACf,0EAA0E;IAC1E,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,6DAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;;AAGA,eAAe;;AAEf;IACI;;QAEI,UAAU;IACd;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;;QAEI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Base Styles */\r\n\r\n.health-monitor-app {\r\n    min-height: 100vh;\r\n    background: linear-gradient(135deg, #e0e7ff 0%, #f3e8ff 50%, #fce7f3 100%);\r\n    font-family: system-ui, -apple-system, sans-serif;\r\n}\r\n\r\n.app-container {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 2rem 1rem;\r\n}\r\n\r\n\r\n/* Header */\r\n\r\n.header {\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.logo-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.75rem;\r\n    margin-bottom: 0.75rem;\r\n}\r\n\r\n.logo-icon {\r\n    position: relative;\r\n}\r\n\r\n.heart-icon {\r\n    width: 3.5rem;\r\n    height: 3.5rem;\r\n    color: #f43f5e;\r\n    animation: pulse 2s infinite;\r\n}\r\n\r\n.heart-icon-ping {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 3.5rem;\r\n    height: 3.5rem;\r\n    color: #f43f5e;\r\n    opacity: 0.2;\r\n    animation: ping 2s infinite;\r\n}\r\n\r\n.app-title {\r\n    font-size: 3.75rem;\r\n    font-weight: 800;\r\n    background: linear-gradient(to right, #4f46e5 0%, #7c3aed 50%, #db2777 100%);\r\n    -webkit-background-clip: text;\r\n    background-clip: text;\r\n    color: transparent;\r\n}\r\n\r\n.app-subtitle {\r\n    color: #4b5563;\r\n    font-size: 1.25rem;\r\n    font-weight: 500;\r\n    margin-bottom: 0.75rem;\r\n}\r\n\r\n.status-indicator {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.status-dot {\r\n    width: 0.5rem;\r\n    height: 0.5rem;\r\n    background-color: #10b981;\r\n    border-radius: 50%;\r\n    animation: pulse 2s infinite;\r\n}\r\n\r\n.status-text {\r\n    font-size: 0.875rem;\r\n    color: #6b7280;\r\n}\r\n\r\n\r\n/* Error Message */\r\n\r\n.error-message {\r\n    margin-bottom: 1.5rem;\r\n    padding: 1rem;\r\n    background-color: #fef2f2;\r\n    border: 1px solid #fecaca;\r\n    border-radius: 0.75rem;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 0.75rem;\r\n}\r\n\r\n.error-icon {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n    color: #ef4444;\r\n    flex-shrink: 0;\r\n    margin-top: 0.125rem;\r\n}\r\n\r\n.error-title {\r\n    color: #991b1b;\r\n    font-weight: 500;\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.error-detail {\r\n    color: #dc2626;\r\n    font-size: 0.875rem;\r\n}\r\n\r\n\r\n/* Main Card */\r\n\r\n.main-card {\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n    backdrop-filter: blur(12px);\r\n    border-radius: 1.5rem;\r\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n    border: 1px solid rgba(255, 255, 255, 0.2);\r\n    overflow: hidden;\r\n}\r\n\r\n/* Prefill Form */\r\n\r\n.prefill-state {\r\n    padding: 2rem 1rem 3rem;\r\n}\r\n\r\n.prefill-card {\r\n    max-width: 760px;\r\n    margin: 0 auto;\r\n    background-color: rgba(255, 255, 255, 0.96);\r\n    border-radius: 1.75rem;\r\n    box-shadow: 0 24px 50px rgba(15, 23, 42, 0.09);\r\n    border: 1px solid rgba(148, 163, 184, 0.16);\r\n    padding: 2rem;\r\n}\r\n\r\n.prefill-header {\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n    gap: 1rem;\r\n    align-items: center;\r\n}\r\n\r\n.prefill-icon-wrap {\r\n    width: 3rem;\r\n    height: 3rem;\r\n    border-radius: 1rem;\r\n    display: grid;\r\n    place-items: center;\r\n    background: #eef2ff;\r\n    color: #4338ca;\r\n}\r\n\r\n.prefill-icon {\r\n    width: 1.4rem;\r\n    height: 1.4rem;\r\n}\r\n\r\n.prefill-title {\r\n    font-size: 1.75rem;\r\n    font-weight: 700;\r\n    color: #111827;\r\n    margin: 0;\r\n}\r\n\r\n.prefill-subtitle {\r\n    margin: 0.5rem 0 0;\r\n    color: #475569;\r\n    line-height: 1.7;\r\n    font-size: 0.98rem;\r\n}\r\n\r\n.prefill-section {\r\n    margin-top: 2rem;\r\n}\r\n\r\n.prefill-section-label {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    color: #0f172a;\r\n    font-weight: 600;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.optional-tag {\r\n    color: #64748b;\r\n    font-size: 0.92rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.ground-truth-inputs {\r\n    display: grid;\r\n    gap: 1rem;\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n@media (min-width: 640px) {\r\n    .ground-truth-inputs.two-column-grid {\r\n        grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    }\r\n}\r\n\r\n.vitals-grid {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .vitals-grid {\r\n        grid-template-columns: repeat(3, minmax(0, 1fr));\r\n    }\r\n}\r\n\r\n.input-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.input-group.full-width {\r\n    grid-column: span 1;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .input-group.full-width {\r\n        grid-column: 1 / -1;\r\n    }\r\n}\r\n\r\n.input-label {\r\n    color: #334155;\r\n    font-size: 0.92rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.input-field {\r\n    width: 100%;\r\n    border: 1px solid #cbd5e1;\r\n    border-radius: 0.95rem;\r\n    padding: 0.95rem 1rem;\r\n    font-size: 1rem;\r\n    color: #0f172a;\r\n    background-color: #f8fafc;\r\n    outline: none;\r\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.input-field:focus {\r\n    border-color: #6366f1;\r\n    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);\r\n}\r\n\r\n.textarea-field {\r\n    min-height: 5rem;\r\n    resize: vertical;\r\n}\r\n\r\n.input-with-unit {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n}\r\n\r\n.input-unit {\r\n    color: #64748b;\r\n    font-size: 0.95rem;\r\n    min-width: 3rem;\r\n}\r\n\r\n.prefill-actions {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-end;\r\n    gap: 0.875rem;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.prefill-start-button {\r\n    position: relative;\r\n    padding: 1rem 1.75rem;\r\n    background: #4338ca;\r\n    color: white;\r\n    border-radius: 1rem;\r\n    font-weight: 700;\r\n    font-size: 1rem;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\r\n    box-shadow: 0 12px 24px rgba(67, 56, 202, 0.18);\r\n}\r\n\r\n.prefill-start-button:hover {\r\n    transform: translateY(-1px);\r\n    background: #4f46e5;\r\n}\r\n\r\n.prefill-cancel-button {\r\n    padding: 0.95rem 1.5rem;\r\n    background-color: #f8fafc;\r\n    color: #334155;\r\n    border-radius: 1rem;\r\n    font-weight: 600;\r\n    border: 1px solid #cbd5e1;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.prefill-cancel-button:hover {\r\n    background-color: #f1f5f9;\r\n}\r\n\r\n/* Idle State */\r\n\r\n.idle-state {\r\n    padding: 3rem;\r\n    text-align: center;\r\n}\r\n\r\n.idle-content {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.camera-icon-container {\r\n    position: relative;\r\n    display: inline-block;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.camera-icon-background {\r\n    position: absolute;\r\n    inset: 0;\r\n    background: linear-gradient(to right, #818cf8 0%, #a78bfa 100%);\r\n    border-radius: 50%;\r\n    filter: blur(2rem);\r\n    opacity: 0.3;\r\n    animation: pulse 2s infinite;\r\n}\r\n\r\n.camera-icon {\r\n    position: relative;\r\n    width: 7rem;\r\n    height: 7rem;\r\n    color: #4f46e5;\r\n}\r\n\r\n.idle-title {\r\n    font-size: 2.25rem;\r\n    font-weight: 700;\r\n    color: #111827;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.idle-description {\r\n    color: #4b5563;\r\n    font-size: 1.125rem;\r\n    margin-bottom: 2rem;\r\n    max-width: 42rem;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    line-height: 1.75;\r\n}\r\n\r\n\r\n/* Start Button */\r\n\r\n.start-button {\r\n    position: relative;\r\n    padding: 1.25rem 2.5rem;\r\n    background: linear-gradient(to right, #4f46e5 0%, #7c3aed 50%, #db2777 100%);\r\n    color: white;\r\n    border-radius: 1rem;\r\n    font-weight: 700;\r\n    font-size: 1.25rem;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 10px 25px rgba(168, 85, 247, 0.3);\r\n    transform: scale(1);\r\n}\r\n\r\n.start-button:hover {\r\n    box-shadow: 0 25px 50px rgba(168, 85, 247, 0.5);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.button-content {\r\n    position: relative;\r\n    z-index: 10;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    justify-content: center;\r\n}\r\n\r\n.button-icon {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n}\r\n\r\n.button-hover {\r\n    position: absolute;\r\n    inset: 0;\r\n    background: linear-gradient(to right, #db2777 0%, #7c3aed 50%, #4f46e5 100%);\r\n    border-radius: 1rem;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n}\r\n\r\n.start-button:hover .button-hover {\r\n    opacity: 1;\r\n}\r\n\r\n\r\n/* Features Grid */\r\n\r\n.features-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 1.5rem;\r\n    margin-top: 4rem;\r\n    max-width: 64rem;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .features-grid {\r\n        grid-template-columns: repeat(4, 1fr);\r\n    }\r\n}\r\n\r\n.feature-card {\r\n    padding: 1.5rem;\r\n    border-radius: 1rem;\r\n    border: 2px solid;\r\n    transition: all 0.3s ease;\r\n    transform: scale(1);\r\n}\r\n\r\n.feature-card:hover {\r\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.feature-card-1 {\r\n    background: linear-gradient(135deg, #ffe4e6 0%, #fce7f3 100%);\r\n    border-color: #fecdd3;\r\n}\r\n\r\n.feature-card-2 {\r\n    background: linear-gradient(135deg, #dbeafe 0%, #cffafe 100%);\r\n    border-color: #bae6fd;\r\n}\r\n\r\n.feature-card-3 {\r\n    background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);\r\n    border-color: #e9d5ff;\r\n}\r\n\r\n.feature-card-4 {\r\n    background: linear-gradient(135deg, #fef3c7 0%, #fef9c3 100%);\r\n    border-color: #fde68a;\r\n}\r\n\r\n.feature-icon {\r\n    width: 3rem;\r\n    height: 3rem;\r\n    margin: 0 auto 1rem;\r\n    display: block;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.feature-card:hover .feature-icon {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.feature-card-1 .feature-icon {\r\n    color: #f43f5e;\r\n}\r\n\r\n.feature-card-2 .feature-icon {\r\n    color: #3b82f6;\r\n}\r\n\r\n.feature-card-3 .feature-icon {\r\n    color: #8b5cf6;\r\n}\r\n\r\n.feature-card-4 .feature-icon {\r\n    color: #f59e0b;\r\n}\r\n\r\n.feature-title {\r\n    font-weight: 700;\r\n    color: #111827;\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.feature-description {\r\n    font-size: 0.875rem;\r\n    color: #4b5563;\r\n}\r\n\r\n\r\n/* Camera State */\r\n\r\n.camera-state {\r\n    padding: 2rem;\r\n}\r\n\r\n.video-container {\r\n    position: relative;\r\n    border-radius: 1.5rem;\r\n    overflow: hidden;\r\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\r\n    margin-bottom: 1.5rem;\r\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.video-preview {\r\n    width: 100%;\r\n    height: 500px;\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n\r\n.video-overlay {\r\n    position: absolute;\r\n    inset: 0;\r\n    border: 4px solid #34d399;\r\n    border-radius: 1.5rem;\r\n    pointer-events: none;\r\n}\r\n\r\n.face-guide {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.face-guide-circle {\r\n    width: 18rem;\r\n    height: 24rem;\r\n    border: 4px solid #86efac;\r\n    border-radius: 50%;\r\n    opacity: 0.4;\r\n    animation: pulse 2s infinite;\r\n}\r\n\r\n.camera-status {\r\n    position: absolute;\r\n    top: 1.5rem;\r\n    left: 1.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    backdrop-filter: blur(4px);\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 9999px;\r\n}\r\n\r\n.status-indicator-dot {\r\n    width: 0.5rem;\r\n    height: 0.5rem;\r\n    background-color: #34d399;\r\n    border-radius: 50%;\r\n    animation: pulse 2s infinite;\r\n}\r\n\r\n.camera-status .status-text {\r\n    color: white;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n}\r\n\r\n.camera-controls {\r\n    text-align: center;\r\n}\r\n\r\n.camera-instructions {\r\n    color: #374151;\r\n    font-size: 1.125rem;\r\n    font-weight: 500;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.control-buttons {\r\n    display: flex;\r\n    gap: 1rem;\r\n    justify-content: center;\r\n}\r\n\r\n.record-button {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    padding: 1rem 2.5rem;\r\n    background: linear-gradient(to right, #f43f5e 0%, #dc2626 100%);\r\n    color: white;\r\n    border-radius: 1rem;\r\n    font-weight: 700;\r\n    font-size: 1.125rem;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 20px 50px rgba(244, 63, 94, 0.3);\r\n    transform: scale(1);\r\n}\r\n\r\n.record-button:hover {\r\n    box-shadow: 0 25px 50px rgba(244, 63, 94, 0.5);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.recording-dot {\r\n    width: 1rem;\r\n    height: 1rem;\r\n    background-color: white;\r\n    border-radius: 50%;\r\n    animation: pulse 2s infinite;\r\n}\r\n\r\n.cancel-button {\r\n    padding: 1rem 2.5rem;\r\n    background-color: #f3f4f6;\r\n    color: #374151;\r\n    border-radius: 1rem;\r\n    font-weight: 700;\r\n    font-size: 1.125rem;\r\n    border: 2px solid #e5e7eb;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.cancel-button:hover {\r\n    background-color: #e5e7eb;\r\n}\r\n\r\n\r\n/* Recording State */\r\n\r\n.recording-state {\r\n    padding: 2rem;\r\n}\r\n\r\n.recording-video-container {\r\n    position: relative;\r\n    border-radius: 1rem;\r\n    overflow: hidden;\r\n    background-color: black;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.recording-video {\r\n    width: 100%;\r\n    height: 480px;\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n\r\n.recording-indicator {\r\n    position: absolute;\r\n    top: 1rem;\r\n    left: 1rem;\r\n    background-color: #ef4444;\r\n    color: white;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 9999px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.recording-dot-active {\r\n    width: 0.75rem;\r\n    height: 0.75rem;\r\n    background-color: white;\r\n    border-radius: 50%;\r\n    animation: pulse 1s infinite;\r\n}\r\n\r\n.recording-timer {\r\n    position: absolute;\r\n    bottom: 1rem;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n    color: white;\r\n    padding: 0.75rem 1.5rem;\r\n    border-radius: 9999px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.timer-icon {\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n}\r\n\r\n.timer-value {\r\n    font-size: 1.5rem;\r\n    font-weight: 700;\r\n}\r\n\r\n.timer-total {\r\n    color: #d1d5db;\r\n}\r\n\r\n.progress-bar-container {\r\n    position: relative;\r\n    height: 0.75rem;\r\n    background-color: #e5e7eb;\r\n    border-radius: 9999px;\r\n    overflow: hidden;\r\n}\r\n\r\n.progress-bar {\r\n    height: 100%;\r\n    background: linear-gradient(to right, #3b82f6 0%, #8b5cf6 100%);\r\n    transition: width 1s ease;\r\n}\r\n\r\n.recording-instructions {\r\n    text-align: center;\r\n    color: #4b5563;\r\n    margin-top: 1rem;\r\n}\r\n\r\n\r\n/* Processing State */\r\n\r\n.processing-state {\r\n    padding: 3rem;\r\n    text-align: center;\r\n}\r\n\r\n.processing-content {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.processing-icon {\r\n    width: 5rem;\r\n    height: 5rem;\r\n    color: #3b82f6;\r\n    animation: spin 2s linear infinite;\r\n    margin: 0 auto 1.5rem;\r\n}\r\n\r\n.processing-title {\r\n    font-size: 1.875rem;\r\n    font-weight: 700;\r\n    color: #1f2937;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.processing-description {\r\n    color: #4b5563;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.processing-progress {\r\n    max-width: 28rem;\r\n    margin: 0 auto;\r\n}\r\n\r\n.progress-bar-processing {\r\n    height: 100%;\r\n    background: linear-gradient(to right, #3b82f6 0%, #8b5cf6 100%);\r\n    transition: width 0.5s ease;\r\n}\r\n\r\n.progress-text {\r\n    color: #6b7280;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n\r\n/* Results State */\r\n\r\n.results-state {\r\n    padding: 2rem;\r\n}\r\n\r\n.results-header {\r\n    text-align: center;\r\n    margin-bottom: 2.5rem;\r\n}\r\n\r\n.success-icon-container {\r\n    position: relative;\r\n    display: inline-block;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.success-icon {\r\n    width: 5rem;\r\n    height: 5rem;\r\n    color: #10b981;\r\n}\r\n\r\n.success-icon-ping {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 5rem;\r\n    height: 5rem;\r\n    color: #10b981;\r\n    opacity: 0.2;\r\n    animation: ping 2s infinite;\r\n}\r\n\r\n.results-title {\r\n    font-size: 2.25rem;\r\n    font-weight: 700;\r\n    color: #111827;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.results-subtitle {\r\n    color: #4b5563;\r\n    font-size: 1.125rem;\r\n}\r\n\r\n\r\n/* Results Grid */\r\n\r\n.results-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 1.25rem;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .results-grid {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .results-grid {\r\n        grid-template-columns: repeat(5, 1fr);\r\n    }\r\n}\r\n\r\n.result-card {\r\n    padding: 1.5rem;\r\n    border-radius: 1.5rem;\r\n    border: 2px solid;\r\n    transition: all 0.3s ease;\r\n    transform: scale(1);\r\n}\r\n\r\n.result-card:hover {\r\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.result-card-1 {\r\n    background: linear-gradient(135deg, #ffe4e6 0%, #fce7f3 100%);\r\n    border-color: #fecdd3;\r\n}\r\n\r\n.result-card-2 {\r\n    background: linear-gradient(135deg, #dbeafe 0%, #cffafe 100%);\r\n    border-color: #bae6fd;\r\n}\r\n\r\n.result-card-3 {\r\n    background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);\r\n    border-color: #e9d5ff;\r\n}\r\n\r\n.result-card-4 {\r\n    background: linear-gradient(135deg, #ffedd5 0%, #fef3c7 100%);\r\n    border-color: #fed7aa;\r\n}\r\n\r\n.result-card-5 {\r\n    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\r\n    border-color: #a7f3d0;\r\n}\r\n\r\n.result-card-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.result-icon {\r\n    width: 2rem;\r\n    height: 2rem;\r\n}\r\n\r\n.result-card-1 .result-icon {\r\n    color: #f43f5e;\r\n}\r\n\r\n.result-card-2 .result-icon {\r\n    color: #3b82f6;\r\n}\r\n\r\n.result-card-3 .result-icon {\r\n    color: #8b5cf6;\r\n}\r\n\r\n.result-card-4 .result-icon {\r\n    color: #f97316;\r\n}\r\n\r\n.result-card-5 .result-icon {\r\n    color: #10b981;\r\n}\r\n\r\n.result-status {\r\n    font-size: 0.75rem;\r\n    padding: 0.25rem 0.75rem;\r\n    border-radius: 9999px;\r\n    font-weight: 500;\r\n}\r\n\r\n.status-normal {\r\n    background-color: #dcfce7;\r\n    color: #166534;\r\n}\r\n\r\n.status-warning {\r\n    background-color: #fef3c7;\r\n    color: #854d0e;\r\n}\r\n\r\n.status-high {\r\n    background-color: #fee2e2;\r\n    color: #991b1b;\r\n}\r\n\r\n.status-below {\r\n    background-color: #dbeafe;\r\n    color: #1e40af;\r\n}\r\n\r\n.result-label {\r\n    font-size: 0.875rem;\r\n    font-weight: 700;\r\n    color: #111827;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.result-value-container {\r\n    display: flex;\r\n    align-items: baseline;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.result-value {\r\n    font-size: 2.25rem;\r\n    font-weight: 700;\r\n    color: #111827;\r\n}\r\n\r\n.result-unit {\r\n    color: #6b7280;\r\n    font-size: 1rem;\r\n}\r\n\r\n\r\n/* Scan Details */\r\n\r\n.scan-details {\r\n    background-color: #f9fafb;\r\n    border-radius: 1rem;\r\n    padding: 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.scan-details-title {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    font-weight: 700;\r\n    color: #111827;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.scan-details-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 1rem;\r\n}\r\n\r\n.detail-label {\r\n    font-size: 0.875rem;\r\n    color: #6b7280;\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.detail-value {\r\n    font-size: 1.125rem;\r\n    font-weight: 700;\r\n    color: #111827;\r\n}\r\n\r\n\r\n/* Disclaimer */\r\n\r\n.disclaimer {\r\n    background-color: #fffbeb;\r\n    border: 2px solid #fcd34d;\r\n    border-radius: 1rem;\r\n    padding: 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 0.75rem;\r\n}\r\n\r\n.disclaimer-icon {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    color: #d97706;\r\n    flex-shrink: 0;\r\n    margin-top: 0.125rem;\r\n}\r\n\r\n.disclaimer-title {\r\n    font-weight: 700;\r\n    color: #78350f;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.disclaimer-text {\r\n    font-size: 0.875rem;\r\n    color: #92400e;\r\n    line-height: 1.5;\r\n}\r\n\r\n\r\n/* New Scan Container */\r\n\r\n.new-scan-container {\r\n    text-align: center;\r\n}\r\n\r\n\r\n/* Footer */\r\n\r\n.footer {\r\n    text-align: center;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.footer-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    background-color: rgba(255, 255, 255, 0.6);\r\n    backdrop-filter: blur(4px);\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 9999px;\r\n}\r\n\r\n.footer-text {\r\n    font-size: 0.875rem;\r\n    color: #4b5563;\r\n}\r\n\r\n\r\n/* Ground Truth Section */\r\n\r\n.ground-truth-section {\r\n    margin-top: 2rem;\r\n    padding: 1.5rem;\r\n    background: linear-gradient(135deg, #fef3c7 0%, #fef3c7 50%, #fce7f3 100%);\r\n    border: 2px solid #fcd34d;\r\n    border-radius: 1rem;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ground-truth-title {\r\n    font-size: 1.25rem;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.ground-truth-description {\r\n    color: #4b5563;\r\n    font-size: 0.95rem;\r\n    margin-bottom: 1.5rem;\r\n    line-height: 1.5;\r\n}\r\n\r\n.ground-truth-inputs {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: 1rem;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.input-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.input-label {\r\n    font-size: 0.875rem;\r\n    font-weight: 600;\r\n    color: #374151;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.input-field {\r\n    padding: 0.75rem;\r\n    border: 2px solid #e5e7eb;\r\n    border-radius: 0.5rem;\r\n    font-size: 1rem;\r\n    font-family: inherit;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.input-field:focus {\r\n    outline: none;\r\n    border-color: #7c3aed;\r\n    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);\r\n    background-color: #f9f5ff;\r\n}\r\n\r\n.textarea-field {\r\n    resize: vertical;\r\n    font-family: inherit;\r\n}\r\n\r\n.save-ground-truth-button {\r\n    width: 100%;\r\n    padding: 0.875rem 1.5rem;\r\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.75rem;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 4px 6px rgba(16, 185, 129, 0.3);\r\n}\r\n\r\n.save-ground-truth-button:hover:not(:disabled) {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 12px rgba(16, 185, 129, 0.4);\r\n    background: linear-gradient(135deg, #059669 0%, #047857 100%);\r\n}\r\n\r\n.save-ground-truth-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.ground-truth-note {\r\n    font-size: 0.8rem;\r\n    color: #6b7280;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.ground-truth-saved {\r\n    margin-top: 2rem;\r\n    padding: 1.5rem;\r\n    background-color: #f0fdf4;\r\n    border: 2px solid #86efac;\r\n    border-radius: 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n}\r\n\r\n.success-icon-small {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    color: #10b981;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.saved-message {\r\n    color: #166534;\r\n    font-weight: 500;\r\n    margin: 0;\r\n}\r\n\r\n\r\n/* Animations */\r\n\r\n@keyframes pulse {\r\n    0%,\r\n    100% {\r\n        opacity: 1;\r\n    }\r\n    50% {\r\n        opacity: 0.5;\r\n    }\r\n}\r\n\r\n@keyframes ping {\r\n    0% {\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n    75%,\r\n    100% {\r\n        transform: scale(2);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
